import React, { useEffect, useState } from 'react';
import { useTownState } from '../context/TownStateContext';
import { fetchMemories, DBMemory } from '../services/firebaseClient';
import './CharacterInfoPanel.css';

const CharacterInfoPanel: React.FC = () => {
    const { selectedCharacter, conversations } = useTownState();
    const [memories, setMemories] = useState<DBMemory[]>([]);

    // Load memories from Firestore subcollection when character is selected
    useEffect(() => {
        if (!selectedCharacter) {
            setMemories([]);
            return;
        }
        let cancelled = false;
        fetchMemories(selectedCharacter.id, 10).then(mems => {
            if (!cancelled) setMemories(mems);
        });
        // Refresh memories every 10 seconds
        const interval = setInterval(() => {
            fetchMemories(selectedCharacter.id, 10).then(mems => {
                if (!cancelled) setMemories(mems);
            });
        }, 10000);
        return () => { cancelled = true; clearInterval(interval); };
    }, [selectedCharacter?.id]);

    if (!selectedCharacter) {
        return (
            <div className="info-panel">
                <div className="info-panel-placeholder">
                    <p>Selecciona un personaje</p>
                </div>
            </div>
        );
    }

    // Emojis for Virtual Software House roles
    let emoji = '👤';
    if (selectedCharacter.role?.includes('Product Manager')) emoji = '📋';
    else if (selectedCharacter.role?.includes('Frontend')) emoji = '🎨';
    else if (selectedCharacter.role?.includes('Backend')) emoji = '⚙️';
    else if (selectedCharacter.role?.includes('QA')) emoji = '🔍';

    return (
        <div className="info-panel">
            <div className="info-panel-header">
                <div className="character-sprite-large">
                    {emoji}
                </div>
                <h2>{selectedCharacter.name}</h2>
            </div>

            <div className="info-section">
                <h3>Status</h3>
                <p>{selectedCharacter.status}</p>
            </div>

            <div className="info-section">
                <h3>Personality</h3>
                <p>{selectedCharacter.personality}</p>
            </div>

            <div className="info-section">
                <h3>Current Task</h3>
                <p>{selectedCharacter.currentTask ?? 'Taking a break.'}</p>
            </div>

            <div className="info-section">
                <h3>Daily Schedule</h3>
                {selectedCharacter.dailySchedule && selectedCharacter.dailySchedule.length > 0 ? (
                    <ul style={{ listStyleType: 'none', padding: 0 }}>
                        {selectedCharacter.dailySchedule.map((item: any, index: number) => (
                            <li key={index} style={{ marginBottom: '8px', fontSize: '0.9em' }}>
                                <strong style={{ color: '#ffd700' }}>{item.time}</strong>: {item.description}
                                <br />
                                <span style={{ opacity: 0.7, fontSize: '0.85em' }}>📍 {item.location}</span>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p>No schedule defined.</p>
                )}
            </div>

            <div className="info-section">
                <h3>Memories</h3>
                {memories.length > 0 ? (
                    <ul>
                        {memories.map((memory, index) => (
                            <li key={index} style={{ marginBottom: '6px' }}>
                                <span style={{ 
                                    fontSize: '0.7em', 
                                    padding: '1px 4px', 
                                    borderRadius: '3px',
                                    backgroundColor: memory.type === 'conversation' ? '#4a5568' : 
                                                     memory.type === 'reflection' ? '#553c9a' : 
                                                     memory.type === 'decision' ? '#2b6cb0' : '#2d3748',
                                    color: '#e2e8f0',
                                    marginRight: '4px'
                                }}>
                                    {memory.type}
                                </span>
                                <span style={{ fontSize: '0.7em', color: '#ffd700' }}>
                                    [{memory.importance}/10]
                                </span>
                                <br />
                                {memory.description}
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p>No memories yet.</p>
                )}
            </div>
        </div>
    );
};

export default CharacterInfoPanel;